import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id CF5F798F-BB0B-4F5A-98C4-3CFADF57BAA3
 * name file-document-alert-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-alert-outline.svg
 * tags
 * - Files / Folders 
 * - Alert / Error 
 */
export const FileDocumentAlertOutlineIcon = createSvgIcon(<><path d="M20 17H22V15H20V17M20 7V13H22V7M6 16H11V18H6M6 12H14V14H6M4 2C2.89 2 2 2.89 2 4V20C2 21.11 2.89 22 4 22H16C17.11 22 18 21.11 18 20V8L12 2M4 4H11V9H16V20H4Z" /></>, 'FileDocumentAlertOutlineIcon');
export default FileDocumentAlertOutlineIcon